import { ValueTransformer } from "typeorm"

export const JsonObject: ValueTransformer = {
  to: (entityValue: any) => JSON.stringify(entityValue),
  from: (databaseValue: any): any => JSON.parse(databaseValue)
}